import { categoryMap, formatReads } from '@/mocks/gossip';
import { allPosts } from '@/mocks/gossip';

const picks = [
  { id: 'z01', label: '同款撞衫 · 逐项打分' },
  { id: 'p03', label: '裙摆掀桌 · 惊险一瞬' },
  { id: 'm01', label: '底妆翻车 · 色号避雷' },
  { id: 'q01', label: '垫肩争议 · 廓形边界' },
];

function momentCards() {
  const items = picks
    .map((k) => allPosts.find((p) => p.id === k.id))
    .filter((p): p is NonNullable<typeof p> => Boolean(p));
  return items.map((p, i) => ({ ...p, label: picks[i].label }));
}

export default function Moments() {
  const cards = momentCards();
  const main = cards[0];
  const rest = cards.slice(1);

  return (
    <section
      id="moments"
      className="relative w-full bg-secondary-50/70 py-16 md:py-20"
    >
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.24em] text-secondary-700">
              <i className="ri-flashlight-line text-base"></i>
              MOMENTS
            </p>
            <h2 className="rule-line font-display text-3xl font-black text-foreground-950 md:text-4xl">
              高能瞬间：红毯名场面集中营
            </h2>
            <p className="mt-6 max-w-xl text-sm leading-relaxed text-foreground-700">
              真正会「被记住」的，往往是那些意料之外的瞬间。把镜头放慢，再看一次当场的小崩溃与小名场面。
            </p>
          </div>
          <a
            href="#pan"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-secondary-800 transition-colors hover:text-primary-600"
          >
            回分类盘点
            <i className="ri-arrow-right-line text-base"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 lg:grid-cols-3">
          {/* 主图卡 */}
          {main && (
            <a
              href="#pan"
              className="group relative col-span-1 block h-[560px] w-full overflow-hidden rounded-xl lg:col-span-1 lg:row-span-2 lg:h-full"
            >
              <img
                src={main.img}
                alt={main.title}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                  <i className="ri-star-fill text-sm"></i>
                  本周头瓜
                </span>
                <h3 className="mt-3 font-display text-2xl font-black leading-snug text-background-50">
                  {main.title}
                </h3>
                <p className="mt-2 text-sm text-background-100/85">{main.brief}</p>
                <p className="mt-3 flex items-center gap-3 text-xs text-background-100/70">
                  <span>{main.label}</span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {formatReads(main.reads)} 围观
                  </span>
                </p>
              </div>
            </a>
          )}

          {/* 右侧小卡组 */}
          <div className="grid grid-cols-2 gap-4 lg:col-span-2 lg:grid-cols-2">
            {rest.map((p) => (
              <a
                key={p.id}
                href="#pan"
                className="group relative block h-64 w-full overflow-hidden rounded-xl lg:h-[266px]"
              >
                <img
                  src={p.img}
                  alt={p.title}
                  className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/10 to-transparent"></div>
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/85 px-2.5 py-1 text-xs font-medium text-foreground-800 backdrop-blur-sm">
                  <i className={`${categoryMap[p.cat]?.icon} text-primary-600`}></i>
                  {categoryMap[p.cat]?.name}
                </span>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="font-display text-base font-bold leading-snug text-background-50">
                    {p.title}
                  </h3>
                  <p className="mt-1.5 text-xs text-accent-200">{p.label}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}